import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import MenuIcon from '@mui/icons-material/Menu';
import { Box, Drawer, ListItem, ListItemText } from '@mui/material';
import CloseButton from 'components/CloseButton';
import SelectStudent from 'components/User/SelectStudent';
import useGetMenuMobile from 'modules/App/consts/menu';
import store from 'store';
import clearApiCacheAndReloadSW from 'utils/serviceWorkerCleanup';

import LogoutIcon from '@common/assets/icons/Logout.svg';
import RBAC from '@common/components/RBAC';

import NavBarItem from '../components/NavBarItem';
import { StyledNavBarIcon, StyledNavBarWrap } from '../components/NavBarItem/styled';
import { StyledBurgerIconButton, StyledBurgerMenuList } from './styled';

function BurgerMenu() {
	const [open, setOpen] = useState(false);

	const navigate = useNavigate();
	const { t } = useTranslation();

	const MenuMobile = useGetMenuMobile();

	const toggleDrawer = (newOpen: boolean) => () => {
		setOpen(newOpen);
	};

	const handleNavigate = (href: string) => {
		navigate(href);
		setOpen(false);
	};

	const handleClickLogOut = async () => {
		await clearApiCacheAndReloadSW();
		store.auth.logout();
	};

	return (
		<>
			<StyledBurgerIconButton size="large" onClick={toggleDrawer(true)}>
				<MenuIcon />
			</StyledBurgerIconButton>
			<Drawer
				open={open}
				onClose={toggleDrawer(false)}
				anchor="bottom"
				sx={{ backdropFilter: 'none' }}
				PaperProps={{
					sx: {
						top: '72px',
						left: '8px',
						width: 'calc(100% - 16px)',
						minWidth: 'auto',
						background: '#fff',
						borderRadius: '20px 20px 0 0',
					},
				}}
			>
				<CloseButton
					background
					onClick={toggleDrawer(false)}
					sx={{
						marginLeft: 'auto',
						marginBottom: '16px',
					}}
				/>

				<Box role="presentation" flex={1} display="flex" flexDirection="column">
					<RBAC granted={['Parent']}>
						<SelectStudent />
					</RBAC>
					<StyledBurgerMenuList>
						<StyledBurgerMenuList>
							{MenuMobile.filter((item) => {
								const userRoles = store.profile.roles.map((r) => r.name);

								if (item.excludeRoles?.some((role) => userRoles.includes(role))) {
									return false;
								}

								if (item.onlyFor?.length) {
									return item.onlyFor.some((role) => userRoles.includes(role));
								}

								return true;
							}).map((item) => (
								<NavBarItem onClick={handleNavigate} key={item.text} {...item} />
							))}
						</StyledBurgerMenuList>
					</StyledBurgerMenuList>
					<StyledBurgerMenuList sx={{ marginTop: 'auto' }}>
						<ListItem disablePadding>
							<StyledNavBarWrap onClick={handleClickLogOut}>
								<StyledNavBarIcon>
									<LogoutIcon />
								</StyledNavBarIcon>
								<ListItemText primary={t('shared.logout')} />
							</StyledNavBarWrap>
						</ListItem>
					</StyledBurgerMenuList>
				</Box>
			</Drawer>
		</>
	);
}

export default observer(BurgerMenu);
